"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientException = void 0;
class ClientException extends Error {
}
exports.ClientException = ClientException;
//# sourceMappingURL=client-exception.js.map